import { useEffect, useRef } from 'react'

// use to compare with previous state/props
export const usePrevious = value => {
  const ref = useRef()

  useEffect(() => {
    ref.current = value
  }, [value])

  return ref.current
}